import gql from 'graphql-tag';

export const LOCAL_USER_FROM_TOKEN = gql`
  query FromToken($token: String) {
    user(token: $token) {
      payload {
        id
        email
        role {
          id
          name
        }
        firstName
        lastName
        phone
        unallowedActions {
          groups
          orders
        }
        venues {
          id
          allowCardReaderPayments
          stripeLocation
          timeZone
          discountCodesEnabled
          discountCodesForRenters
          venueConfig {
            promptRenterAgreement
          }
        }
      }
      error
    }
  }
`;
